<template>
  <div class="relative">
    <!-- Collapsible Content -->
    <div v-if="isCollapsible" class="relative">
      <!-- Content with height-based collapse -->
      <div
        class="overflow-hidden transition-all duration-300 ease-in-out"
        :class="isExpanded ? 'max-h-none' : 'max-h-[130px]'"
      >
        <slot />
      </div>

      <!-- Gradient fade overlay when collapsed -->
      <div
        v-if="!isExpanded"
        class="pointer-events-none absolute bottom-[35px] left-0 right-0 h-16 md:bottom-[65px]"
        style="
          background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.03) 2.5%,
            rgba(255, 255, 255, 0.8) 28.5%,
            #fff 100%
          );
        "
      ></div>

      <!-- Toggle Button (centered at bottom) -->
      <div class="relative mt-4 flex w-full justify-center">
        <app-button
          type="toggle"
          variant="lila"
          :expanded="isExpanded"
          size="desktop"
          arrow-type="double"
          @click="toggleExpanded"
        >
          {{ isExpanded ? 'Läs mindre' : 'Läs mer' }}
        </app-button>
      </div>
    </div>

    <!-- Non-collapsible Content -->
    <div v-else>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  isCollapsible: boolean
}

defineProps<Props>()

// Collapsible state
const isExpanded = ref(false)

const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value
}
</script>
